import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDrag } from 'react-use-gesture'
import { BodyContext } from '~/context/BodyContext.js'
import { Swiper, SwiperSlide } from "swiper/react";
import { useWindowDimensions } from '~/hooks';
import 'swiper/swiper.scss';
import J from 'juicy-ui'
import C from '~/components'
import gsap from 'gsap';
import { Howl, Howler } from 'howler';

export const Catalogue = props => {
    const [CT] = useContext(BodyContext);
    const SwiperRef = useRef(null);
    const { height: windowHeight, width: windowWidth } = useWindowDimensions();
    const [swiperWidth, set_swiperWidth] = useState(1100);
    const [swiperSlidesPerView, set_swiperSlidesPerView] = useState(2);
    const [tl3isDone, set_tl3isDone] = useState(false);
    const [tl4isDone, set_tl4isDone] = useState(false);
    const [tl5isDone, set_tl5isDone] = useState(false);
    const [tl6isDone, set_tl6isDone] = useState(false);
    const [tl7isDone, set_tl7isDone] = useState(false);
    const [tl8isDone, set_tl8isDone] = useState(false);
    const [tl9isDone, set_tl9isDone] = useState(false);
    const [shzplace, set_shzplace] = useState(false);
    const img = (name) => require('~/assets/images/pages/home/' + name).default
    const tlOptions = { duration: 1 }
    const tl = gsap.timeline({ duration: 1 });

    useEffect(() => {
        // p1
        gsap.from(".p1 .i-0", { ...tlOptions, opacity: 0, x: 0, y: 0, });
        tl.from(".p1 .i-1", { ...tlOptions, opacity: 0, x: -300, });
        tl.from(".p1 .i-2", { ...tlOptions, opacity: 0, x: -300, });
        gsap.from(".p1 .i-3", { ...tlOptions, opacity: 0, x: 1000, duration: 2, delay: 1 });
        gsap.from(".p1 .i-4", { ...tlOptions, opacity: 0, x: 0, y: -200, delay: 1 });
        gsap.from(".p1 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 200, delay: 1.5 });
        gsap.from(".p1 .i-6", { ...tlOptions, opacity: 0, x: 0, y: -200, delay: 2 });
        gsap.from(".p1 .i-7", { ...tlOptions, opacity: 0, });
        gsap.from(".p1 .i-8", { ...tlOptions, opacity: 0, });
        tl.from(".p1 .i-9", { ...tlOptions, opacity: 0, });
        gsap.from(".p1 .i-10", { ...tlOptions, opacity: 0, delay: 3.2 });
        gsap.from(".p1 .i-11", { ...tlOptions, opacity: 0, delay: 3.4 });
        gsap.from(".p1 .i-12", { ...tlOptions, opacity: 0, delay: 3.6 });
        // p2
        gsap.from(".p2 .i-0", { ...tlOptions, opacity: 0, x: 0, y: -300, });
        tl.from(".p2 .i-1", { ...tlOptions, opacity: 0, x: -300, y: 0 });
        !(windowWidth <= 700) && tl.from(".p2 .i-2", { ...tlOptions, opacity: 0, x: 0, y: -300 });
        gsap.from(".p2 .i-3", { ...tlOptions, opacity: 0, x: 0, y: 300, delay: 2 });
        gsap.from(".p2 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 300, delay: 2 });
        // 
        if (windowWidth <= 700) {
            set_swiperWidth((windowWidth) - 30)
            set_swiperSlidesPerView(1)
            gsap.to("._TO_FIRST", { opacity: 1, x: 25, y: -5 });
            gsap.to(".p1 .i-10", { ...tlOptions, x: -200, y: 50 });
            gsap.to(".p1 .i-11", { ...tlOptions, x: -200, y: 50 });
            gsap.to(".p1 .i-12", { ...tlOptions, x: -200, y: 50 });
            gsap.to(".p2 .i-2", { ...tlOptions, opacity: 1, x: -50, y: -100 });
            gsap.to(".p1 .i-00", { opacity: 0 });
            gsap.to(".p2 .i-00", { opacity: 0 });
            gsap.to(".p3 .i-00", { opacity: 0 });
            gsap.to(".p4 .i-00", { opacity: 0 });
            gsap.to(".p5 .i-00", { opacity: 0 });
            gsap.to(".p6 .i-00", { opacity: 0 });
            gsap.to(".p7 .i-00", { opacity: 0 });
            gsap.to(".p8 .i-00", { opacity: 0 });
            gsap.to(".p9 .i-00", { opacity: 0 });
        }

        changingForShzplace(2, [
            <J.Image className="i-3 v" src={img('hafiz.jpg')} />,
            <J.Image className="i-3 v" src={img('saadi.jpg')} />,
            <J.Image className="i-3 v" src={img('shahcheragh.jpg')} />,
            <J.Image className="i-3 v" src={img('karimkhan.jpg')} />,
            <J.Image className="i-3 v" src={img('narenjestan.jpg')} />,
            <J.Image className="i-3 v" src={img('eram.jpg')} />,
            <J.Image className="i-3 v" src={img('nasiralmolk.jpg')} />,
            <J.Image className="i-3 v" src={img('bazarvakil.jpg')} />,
            <J.Image className="i-3 v" src={img('takhtejamshid.jpg')} />,
            <J.Image className="i-3 v" src={img('naghsherostam.jpg')} />,
        ])

        // const sound = new Howl({
        //     src: [require('~/assets/sounds/bg.mp3').default],
        //     autoplay: true,
        //     loop: true,
        // });

    }, [])
    const handleSlide = (i) => {
        if ((i == 1 || i == 2) && !tl3isDone) {
            gsap.from(".p3 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p3 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p3 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p3 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p3 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p3 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p3 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl3isDone(true)
        }
        if ((i == 2 || i == 3) && !tl4isDone) {
            gsap.from(".p4 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p4 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p4 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p4 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p4 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p4 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p4 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl4isDone(true)
        }
        if ((i == 3 || i == 4) && !tl5isDone) {
            gsap.from(".p5 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p5 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p5 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p5 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p5 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p5 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p5 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl5isDone(true)
        }
        if ((i == 4 || i == 5) && !tl6isDone) {
            gsap.from(".p6 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p6 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p6 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p6 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p6 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1 });
            gsap.from(".p6 .i-4", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1.2 });
            gsap.from(".p6 .i-5", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1.4 });
            gsap.from(".p6 .i-6", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1.6 });
            gsap.from(".p6 .i-8", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1.6 });
            gsap.from(".p6 .i-9", { ...tlOptions, opacity: 0, x: 300, y: 0, delay: 1.6 });
            set_tl6isDone(true)
        }
        if ((i == 5 || i == 6) && !tl7isDone) {
            gsap.from(".p7 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p7 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p7 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p7 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p7 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p7 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p7 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl7isDone(true)
        }
        if ((i == 6 || i == 7) && !tl8isDone) {
            gsap.from(".p8 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p8 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p8 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p8 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p8 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p8 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p8 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl8isDone(true)
        }
        if ((i == 7 || i == 8) && !tl9isDone) {
            gsap.from(".p9 .i-00", { ...tlOptions, opacity: 0, x: -300, y: 0, delay: 2 });
            tl.from(".p9 .i-0", { ...tlOptions, opacity: 0, x: -300, y: 0, });
            tl.from(".p9 .i-1", { ...tlOptions, opacity: 0, x: 0, y: 300, });
            tl.from(".p9 .i-2", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p9 .i-3", { ...tlOptions, opacity: 0, x: 300, y: 0, });
            gsap.from(".p9 .i-4", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            gsap.from(".p9 .i-5", { ...tlOptions, opacity: 0, x: 0, y: 0, delay: 1 });
            set_tl9isDone(true)
        }
    }
    const openLink = (link) => {
        window.open(link, '_blank')
    }
    const openPopup = (title = 'توضیحات', content) => {
        CT.popup.open(null, {
            title: title,
            body: <>
                <div className="POP_content">
                    {content}
                </div>
            </>,
            modify: {
                confirmButtonText: 'تایید',
                showConfirmButton: false
            }
        })
    }
    const changingForShzplace = (second = 2, list = []) => {
        let index = 0
        let ret = null
        const timer = setInterval(() => {
            index = index == list.length - 1 ? 0 : index + 1
            ret = list[index]
            set_shzplace(ret)
        }, (second * 1000));
    }

    return (
        <div className="CATALOGUE">
            <div className="_TO_FIRST">
                <J.Btn iconName="ri-arrow-go-back-line" onClick={() => SwiperRef.current.swiper.slideTo(0)} />
            </div>
            <Swiper
                ref={SwiperRef}
                width={swiperWidth}
                slidesPerView={swiperSlidesPerView}
                className="custome_swiper"
                onSlideChange={(swiper) => handleSlide(swiper.activeIndex)}
            >
                <SwiperSlide>
                    <div className="paper p1">
                        <J.Image className="i-0" width={'100%'} src={img('0.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('1.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('2.png')} />
                        <J.Image className="i-3" width={'100%'} src={img('3.png')} />
                        <J.Image className="i-4" width={'100%'} src={img('4.png')} />
                        <J.Image className="i-5" width={'100%'} src={img('5.png')} />
                        <J.Image className="i-6" width={'100%'} src={img('6.png')} />
                        <div className="i-7 t">
                            <span>
                                هتل تالار شیراز
                            </span>
                        </div>
                        <div className="i-8 t">
                            <span>
                                TALAR HOTEL - SHIRAZ
                            </span>
                        </div>
                        <div className="i-9 a">
                            <J.Btn title="رزرو اتاق" onClick={() => openLink('https://hotel-talar-shiraz.iibooking.com/')} />
                        </div>
                        <div className="i-10 a">
                            <J.Btn iconName="ri-phone-fill" onClick={() => openLink('tel:+987132245544')} />
                        </div>
                        <div className="i-11 a">
                            <J.Btn iconName="ri-instagram-line" onClick={() => openLink('https://www.instagram.com/talarhotel/')} />
                        </div>
                        <div className="i-12 a">
                            <J.Btn iconName="ri-global-line" onClick={() => openLink('https://hoteltalar.com/')} />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p2">
                        <J.Image className="i-0" width={'100%'} src={img('7.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('2.png')} />
                        <div style={{ cursor: 'pointer' }} onClick={() => openLink('https://www.instagram.com/p/CfUEdvVKBDt/')} >
                            <J.Image className="i-2 v" src={img('intro.gif')} />
                        </div>
                        <div className="i-3 a">
                            <J.Btn title="رستوران" onClick={() => SwiperRef.current.swiper.slideTo(2)} />
                            <J.Btn title="کافی شاپ" onClick={() => SwiperRef.current.swiper.slideTo(3)} />
                            <J.Btn title="سالن همایش" onClick={() => SwiperRef.current.swiper.slideTo(4)} />
                        </div>
                        <div className="i-4 a">
                            <J.Btn title="اتاق ها" onClick={() => SwiperRef.current.swiper.slideTo(5)} />
                            <J.Btn title="لابی" onClick={() => SwiperRef.current.swiper.slideTo(6)} />
                            <J.Btn title="گردشگری" onClick={() => SwiperRef.current.swiper.slideTo(7)} />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p3">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />
                        <J.Image className="i-3 v" src={img('restaurant.jpg')} />
                        <div className="i-4 t">
                            <p>
                                اگر علاقمند به غذاهای سنتی ایرانی هستید، هتل تالار بهترین انتخاب شما خواهد بود، در منوی رستوران این هتل، تمامی غذاهای سنتی مورد علاقه خود را خواهید دید.
                            </p>
                        </div>
                        <div className="i-5 t">
                            <p>
                                رستوران
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p4">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />
                        <J.Image className="i-3 v" src={img('cafe.jpg')} />
                        <div className="i-4 t">
                            <p>
                                نوشیدنی های سرد و گرم متنوعی در این کافه وجود دارد که می توانید از آن ها لذت ببرید، همچنین، میان وعده های سبک و انواع نوشیدنی های خوشمزه ی کافه هتل تالار به شما پیشنهاد  داده میشود.

                            </p>
                        </div>
                        <div className="i-5 t">
                            <p>
                                کافی شاپ
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p5">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />
                        <J.Image className="i-3 v" src={img('salon.jpg')} />
                        <div className="i-4 t">
                            <p>
                                امکانات و تجهیزات مدرن سالن همایش ، این سالن را برای رویدادهای علمی، تجاری و شرکت ها به یک گزینه حتمی
                                تبدیل کرده است.
                                آماده ی جلسات رسمی و گردهمایی های خصوصی شما تا ظرفیت 140 نفر هستیم.
                                بهترین خدمات برای گردهمائی ها و مراسم مختلف تجاری ‌در سالن همایش هتل تالار قابل ارائه است.
                            </p>
                        </div>
                        <div className="i-5 t">
                            <p>
                                سالن همایش
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p6">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />
                        <a className="i-3 c" onClick={() => openPopup('دو تخته توئین', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-2Bed-twin_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                20 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-2Bed-twin.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        دو تخته توئین
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a className="i-4 c" onClick={() => openPopup('دو تخته دبل', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-2Bed-double_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                20 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-2Bed-double.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        دو تخته دبل
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a className="i-5 c" onClick={() => openPopup('سه تخته تریپل', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-3Bed-tripple_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                25 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-3Bed-tripple.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        سه تخته تریپل
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a className="i-6 c" onClick={() => openPopup('سه تخته دبل', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-3Bed-double_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                25 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-3Bed-double.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        سه تخته دبل
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a className="i-8 c" onClick={() => openPopup('سوییت', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-sweet_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                40 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-sweet.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        سوئیت
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a className="i-9 c" onClick={() => openPopup('سوییت آپارتمان', <>
                            <div style={{ borderRadius: '20px', overflow: 'hidden', marginBottom: '20px' }}>
                                <video style={{ width: '100%' }} autoPlay loop>
                                    <source src={img('room-sweet-apar_compressed.mp4')} type="video/mp4" />
                                </video>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <div style={{ width: '30%', padding: '12px' }}>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                متراژ
                                            </span>
                                        </div>
                                        <div className="value">
                                            <span>
                                                40 متر
                                            </span>
                                        </div>
                                    </div>
                                    <div className="record">
                                        <div className="key">
                                            <span>
                                                امکانات
                                            </span>
                                        </div>
                                        <div className="value -list">
                                            <span>
                                                LED 32 اینچ
                                            </span>
                                            <span>
                                                اینترنت پرسرعت رایگان
                                            </span>
                                            <span>
                                                یخچال مینی‌بار
                                            </span>
                                            <span>
                                                پک بهداشتی، شامپو سر - بدن، مسواک، خمیر دندان
                                            </span>
                                            <span>
                                                گاو صندوق
                                            </span>
                                            <span>
                                                ظروف کامل آشپزخانه
                                            </span>
                                            <span>
                                                آشپزخانه
                                            </span>
                                            <span>
                                                چای ساز
                                            </span>
                                            <span>
                                                سینک ظرف شویی
                                            </span>
                                            <span>
                                                مواد شوینده
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '70%', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px' }}>
                                    <J.Image src={img('room-sweet-apar.jpg')} />
                                </div>
                            </div>
                        </>)}>
                            <i className="ri-home-4-line" />
                            <div className="t">
                                <div className="title">
                                    <p>
                                        سوئیت آپارتمان
                                    </p>
                                </div>
                            </div>
                        </a>
                        <div className="i-7 t">
                            <p>
                                اتاق ها
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p7">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />
                        <J.Image className="i-3 v" src={img('lobbey.gif')} />
                        <div className="i-4 t">
                            <p>

                            </p>
                        </div>
                        <div className="i-5 t">
                            <p>
                                لابی
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p8">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-2" width={'100%'} src={img('11.png')} />

                        {shzplace}
                        <div className="i-4 t">
                            <p>

                                دسترسی به پرطرفدارترین جاذبه های گردشگری شیراز، از جمله دلایل محبوبیت هتل تالار به شمار میرود.
                                <br />
                                جاذبه های گردشگری شیراز:
                                آرامگاه حافظ،
                                آرامگاه سعدی،
                                حرم احمدبن موسی ملقب به شاهچراغ،
                                ارگ کریمخانی و مجموعه زندیه،
                                بازار وکیل،
                                باغ ارم،
                                باغ عفیف آباد،
                                باغ نارنجستان،
                                باغ جهان نما،
                                تخت جمشید،
                                نقش رستم،
                                پاسارگاد و ...
                            </p>
                        </div>
                        <div className="i-5 t">
                            <p>
                                گردشگری
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p9">
                        <J.Image className="i-0" width={'100%'} src={img('9.png')} />
                        <J.Image className="i-1" width={'100%'} src={img('10.png')} />
                        <J.Image className="i-3 v" src={img('qr.png')} />
                        <div className="i-4 t">
                            <p>
                                کد را توسط موبایل اسکن کنید و کاتالوگ را به دوستان خود معرفی کنید
                            </p>
                        </div>
                        <J.Image className="i-00" width={'100%'} src={img('2.png')} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="paper p10">
                        <J.Image className="i-1" src={img('lobbey5.jpg')} />
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}
